<div class="max-w-8xl mx-auto flex flex-col items-center gap-4 p-6 sm:flex-row sm:justify-between">
  <div class="text-muted-foreground text-sm">
    {{ version }}
  </div>

  <div class="flex items-center gap-4">
    <a
      class="text-muted-foreground hover:text-primary text-sm transition-colors"
      href="https://kinexon-sports.com/privacy-policy/"
      rel="noopener noreferrer"
      target="_blank"
    >
      {{ 'app.privacy' | translate }}
    </a>
    <a
      class="text-muted-foreground hover:text-primary text-sm transition-colors"
      href="https://kinexon-sports.com/general-terms-and-conditions/"
      rel="noopener noreferrer"
      target="_blank"
    >
      {{ 'app.terms' | translate }}
    </a>
  </div>
</div>
